import Loose from './loose';
import Strict from './strict';

export {
  Loose,
  Strict,
};



// WEBPACK FOOTER //
// src/plugins/bindRowsWithHeaders/bindStrategies/index.js